﻿<div class="card rdo-card invisible" [class.active]="selected" [class.rdo-card-default]="!selected" [class.rdo-card-highlight]="selected"
  [class.invisible]="hidden" title="{{getTitle()}} " (click)="select()">

  <div class="card-header">
    <div class="card-title text-uppercase">
      <rdo-category-icon [category]="cardData.CategoryIcon || cardData.RouseCategory" class="nav-card-icon" />&nbsp;
      {{getTitle()}}
    </div>
  </div>
  <div class="card-body container-fluid">
    <div class="row">
      <div class="col-6">
        @if (isBenchmarkMode()) {
          <div class="card-title">
            {{'main.tabs.equipment.product_types.nav_card.compared_revenue' | translate}}
          </div>
          <div class="rdo-card-metric">
            {{cardData.RevenueBenchmarked | rdoCurrency:true:translateService.currentLang}} / <span [ngClass]="{'text-danger' : cardData.RevenueBenchmarkedDifference < 0}">
            {{cardData.RevenueBenchmarkedDifference | rdoCurrency:true:translateService.currentLang}}
          </span>
        </div>
      }
      @if (!isBenchmarkMode()) {
        <div class="card-title">
          {{'main.tabs.equipment.product_types.nav_card.total_revenue' | translate}}
        </div>
        <div class="rdo-card-metric">
          {{cardData.RevenueTotal | rdoCurrency:true:translateService.currentLang}} / <span [ngClass]="{'text-danger' : cardData.RevenueBookDifference < 0}">
          {{cardData.RevenueBookDifference | rdoCurrency:true:translateService.currentLang}}
        </span>
      </div>
    }
  </div>
  <div class="col-6 text-end">
    <div class="card-title">
      @if (!allRatesMode) {
        <span>{{'main.tabs.equipment.product_types.nav_card.compared_util' | translate}}</span>
      }
      @if (allRatesMode) {
        <span>{{'main.tabs.equipment.product_types.nav_card.total_util' | translate}}</span>
      }
    </div>
    <div class="rdo-card-metric">
      <span [rdo-dynamic-pie]="cardData.PhysicalUtilization * 100" class="pie"></span>&nbsp;
      @if (!allRatesMode) {
        <span>
          {{cardData.PhysicalUtilization | percent:'1.1-1'}} / <span [ngClass]="{'text-danger': (cardData.PhysicalUtilization - cardData.PhysicalUtilizationBench) < 0}">
          {{cardData.PhysicalUtilization - cardData.PhysicalUtilizationBench | percent:'1.1-1'}}
        </span>
      </span>
    }
    @if (allRatesMode) {
      <span>{{cardData.PhysicalUtilization | percent:'1.1-1'}}</span>
    }
  </div>
</div>
</div>
</div>
</div>
